import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import TextEditorTool from '../TextEditorTool';
import TextEditorToolCaret from '../TextEditorToolCaret';

import styles from './DropdownTextEditorToolToggle.scss';

const DropdownTextEditorToolToggle = ({
  children,
  className,
  isOpened,
  onToggle,
  tooltip,
}) => (
  <TextEditorTool
    onToggle={onToggle}
    tooltip={tooltip}
    active={isOpened}
    className={cx(styles.tool, className, { [styles.openedTool]: isOpened })}
  >
    {children}
    <TextEditorToolCaret isOpened={isOpened} className={styles.caret} />
  </TextEditorTool>
);

DropdownTextEditorToolToggle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isOpened: PropTypes.bool,
  tooltip: PropTypes.string,
  onToggle: PropTypes.func,
};

export default DropdownTextEditorToolToggle;
